import './Tabs.css';
import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { forwardRef } from 'react';

export interface StoneXTabProps {
  label?: React.ReactNode;
  tabIndex?: number;
  isActive?: boolean;
  showCloseButton?: boolean;
  onClick?: (index: number) => void;
  onClose?: (index: number) => void;
}

const StoneXTab = forwardRef<HTMLDivElement, StoneXTabProps>((props, ref) => {
  const { label, tabIndex, isActive, showCloseButton, onClick, onClose } = props;

  return <div
    ref={ref}
    key={tabIndex}
    className={`tab ${isActive ? 'active' : ''}`}
    onClick={() => onClick?.(tabIndex!)}
  >
    {label}

    {showCloseButton && <IconButton sx={{marginLeft: '5px'}} size='small' onClick={(event: any) => {
      event.stopPropagation();
      onClose?.(tabIndex!);
    }}>
        <Close fontSize="inherit" />
      </IconButton>
    }
   </div>
});

export default StoneXTab;
